var map = {
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./notas/notas.module": [
		"./src/app/notas/notas.module.ts",
		"notas-notas-module~pages-pages-module~student-student-module",
		"common",
		"notas-notas-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"notas-notas-module~pages-pages-module~student-student-module",
		"pages-pages-module~student-student-module",
		"common",
		"pages-pages-module"
	],
	"./student/student.module": [
		"./src/app/student/student.module.ts",
		"notas-notas-module~pages-pages-module~student-student-module",
		"pages-pages-module~student-student-module",
		"common",
		"student-student-module"
	],
	"./vote/vote.module": [
		"./src/app/vote/vote.module.ts",
		"common",
		"vote-vote-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;